<template>
  <div class="page-content transactionHistory">
    <h1 class="page-title">{{ $locale("sideMenu.reports.shopTransaction") }}</h1>

    <!-- Search Area -->
    <el-row :gutter="10" class="search-area">
      <el-col  :md="24" :lg="20" >

            <DatePickerGroup
              v-bind:start="timeValue1"
              v-bind:end="timeValue2"
              @setFatherDate="getDate"
            ></DatePickerGroup>
            <el-input :placeholder="$locale('trans.koisk.search.p')" v-model="searchInput" @keyup.enter.native="search" class="searchMaxWidth makeLeft">
              <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                style="cusor: pointer;" @click="search"
              ></i>
            </el-input>
            <el-button @click="search" class="egl-btn-yellow makeLeft">{{
              $locale("global.search")
            }}</el-button>

      </el-col>
      <el-col :md="24"  :lg="4">
        <el-button style="min-width: 200px;margin-left: 20px;" class="egl-btn-yellow float-right" v-print="printObj">{{ $locale("global.printBtn") }}</el-button>
        <el-button @click="exportCsv" class="egl-btn-yellow float-right" style="margin-top:20px;"
          >{{ $locale("global.exportToCSV") }}</el-button
        >
      </el-col>
    </el-row>

    <div class="table-module">
      <!-- <el-row class="search-area">
        <el-col class="ta-r">
          <el-button class="egl-btn-yellow" @click="openCreateDialog">{{ $locale("global.create") }}</el-button>
        </el-col>
      </el-row> -->
      <div id="print">
        <Table
          :title="table"
          :data="tableData"
          ref="father"
          :size="size"
          :currentPage="currentPage"
          :salesStatusObj="salesStatus"
          :taxRatesMapObj="taxRatesMap"
          :paymentTypeList="paymentTypes"
          :goodList="goodsList"
        />
      </div>
      <CommPagination
        :total="count"
        :curPage="currentPage"
        @current-change="pageChange"
        :pageSize="size"
      />
    </div>

    <!-- <Dialog
      :visible="isOpen"
      :titleText="$locale('trans.koisk.title')"
      :type="type"
      :btnText="type === 'edit' ? $locale('global.update') : $locale('global.confirm')"
      :oneButton="type === 'edit' ? false : true"
      :closeAction="toggle"
      :confirmAction="toggle"
      v-if="tableData.length > 0"
    >
      <div class="section">
        <div class="sectionInner">
          <Card :title="$locale('trans.koisk.transid')" :content="detailData.searchId" />
          <Card title="日时" :content="detailData.transactionCreateTime" />
        </div>
      </div>
      <hr class="dotted" />
      <div class="section">
        <div class="sectionInner">
          <Card
            :title="$locale('inventoryLog.name')"
            :content="detailData.productName"
            v-if="type !== 'edit'"
          />
          <Card :title="$locale('inventoryLog.name')" type="select" value="コーヒー" v-else />
          <Card title="數量" :content="detailData.qty" v-if="type !== 'edit'" />
          <Card title="數量" type="select" value="2" v-else />
          <Card :title="$locale('global.department')" :content="detailData.group" />
          <Card :title="$locale('trans.koisk.salesgroup')" :content="detailData.productType" />
        </div>
        <div class="sectionInner">
          <Card :title="$locale('global.unitPrice')" :content="'¥' + detailData.unitPrice" />
          <Card :title="$locale('global.amount')" :content="'¥' + detailData.total" />
          <Card :title="$locale('global.coupon')" content="/" v-if="type !== 'edit'" />
          <Card :title="$locale('global.coupon')" :value="'AAA'+$locale('global.coupon')" type="select" v-else />
          <Card :title="$locale('global.taxRate')" :content="detailData.taxRate" />
        </div>
      </div>
      <hr class="dotted" />
      <div class="section">
        <div class="sectionInner">
          <Card :title="$locale('trans.report.zhLastName')" :content="detailData.payerLastNameHant" />
          <Card :title="$locale('trans.report.zhFirstName')" :content="detailData.payerFirstNameHant" />
          <Card :title="$locale('trans.report.jpLastName')" :content="detailData.payerLastNameSyl" />
          <Card :title="$locale('trans.report.jpFirstName')" :content="detailData.payerFirstNameSyl" />
        </div>
        <div class="sectionInner">
          <Card :title="$locale('setting.brand.tel')" :content="detailData.mobile" />
          <Card :title="$locale('global.email')" :content="detailData.email" />
          <Card title="Account" :content="detailData.userId" />
        </div>
      </div>
      <hr class="dotted" />
      <div class="section">
        <div class="sectionInner">
          <Card :title="$locale('trans.report.paymentMethod')" :content="detailData.paymentName" />
          <Card :title="$locale('global.status')" :content="detailData.status" />
          <Card :title="$locale('global.status')" :content="detailData.operator" />
        </div>
      </div>
    </Dialog> -->
    <el-dialog
      :visible.sync="isCreateOpen"
      width="1342px"
      class="egl-dialog-elm"
      @close="closeDialog"
      :title="titleMapping[type]"
      :close-on-click-modal="false"
    >
      <div class="form-module">
        <el-form
          label-position="top"
          :model="transCreateForm"
          ref="createForm"
          :disabled="type === 'info'"
          :rules="formRules"
        >
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item :label="$locale('trans.koisk.transid')" prop="searchId">{{transCreateForm.searchId || "/"}}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$locale('trans.report.ticketing.time')">
                <el-row :gutter="10">
                  <el-col :span="15">
                    <CommDatePicker
                      v-model="transCreateForm.date"
                      :value.sync="transCreateForm.date"
                      width="100%"
                      :showWeekly="true"
                      :pickerOptions="datePickerOptions"
                    />
                  </el-col>
                  <el-col :span="4">
                    <el-input
                      :placeholder="$locale('trans.report.ticketing.plsInputTime')"
                      v-model="transCreateForm.hour"
                      @input="(value) => hourMinuteLimit_fn(this.transCreateForm, value, 'hour')"
                    />
                  </el-col>
                  <el-col :span="1" style="text-align:center;">:</el-col>
                  <el-col :span="4">
                    <el-input
                      :placeholder="$locale('trans.report.ticketing.plsInputTime')"
                      v-model="transCreateForm.minute"
                      @input="(value) => hourMinuteLimit_fn(this.transCreateForm, value, 'minute')"
                    />
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="line"></div>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item :label="$locale('trans.report.stand.product')" prop="goodsId">
                <el-select
                :placeholder="$locale('trans.report.stand.plsSelectProduct')"
                v-model="transCreateForm.goodsId"
                @change="setPrice"
                filterable
                >
                  <el-option
                    v-for="(item, idx) in goodsList"
                    :key="idx"
                    :label="item.goodsName"
                    :value="item.goodsId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item :label="$locale('global.quantity')" prop="qty">
                <el-input
                  :placeholder="$locale('form.plsEnterQuantity')"
                  v-model.number="transCreateForm.qty"
                  :disabled="transCreateForm.couponTypeId !== ''"
                />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item :label="$locale('global.department')" prop="groupId">{{transCreateForm.groupId || "/"}}</el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item :label="$locale('trans.koisk.salesgroup')" prop="tradeGroupId">{{transCreateForm.tradeGroupId || "/"}}</el-form-item>
            </el-col>
          </el-row>
          <div class="line"></div>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item :label="$locale('global.unitPrice')" prop="unitPrice">{{"¥" + transCreateForm.unitPrice}}</el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item :label="$locale('global.amount')" prop="totalAmount">{{"¥" + totalPrice}}</el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item :label="$locale('trans.report.ticketing.coupon')" prop="couponTypeId">
                <!-- <el-select
                  :placeholder="$locale('trans.report.stand.plsSelectCoupon')"
                  v-model="transCreateForm.couponTypeId"
                  :clearable="true"
                  @change="selectCoupon_fn"
                >
                  <el-option
                    v-for="(item, idx) in couponTypes"
                    :key="idx"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select> -->
                <remote-select
                  v-model="transCreateForm.couponTypeId"
                  :formValue.sync="transCreateForm.couponTypeId"
                  :actionType="type"
                  :isMultiple="false"
                  @selectAll="arr => transCreateForm.couponTypeId = arr"
                  @change="selectCoupon_fn"
                ></remote-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item :label="$locale('global.taxRate')" prop="taxRate">{{taxRatesMap[transCreateForm.taxRate] || "/"}}</el-form-item>
            </el-col>
          </el-row>
          <div class="line"></div>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item :label="$locale('trans.report.ticketing.zhFirstName')">{{transCreateForm.zh_firstName || "/"}}</el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$locale('trans.report.ticketing.zhLastName')">{{transCreateForm.zh_lastName || "/"}}</el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$locale('trans.report.ticketing.jpFirstName')">{{transCreateForm.jp_firstName || "/"}}</el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$locale('trans.report.ticketing.jpLastName')">{{transCreateForm.jp_lastName || "/"}}</el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item :label="$locale('setting.brand.tel')">{{transCreateForm.phone || "/"}}</el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$locale('global.email')">{{transCreateForm.email || "/"}}</el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$locale('trans.report.ticketing.memberNumber')">{{transCreateForm.membershipNumber || "/"}}</el-form-item>
            </el-col>
          </el-row>
          <div class="line"></div>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item :label="$locale('trans.report.ticketing.payMethod')">
                <el-select :placeholder="$locale('trans.report.ticketing.plsSelectPayMethod')" v-model="transCreateForm.paymentTypeId">
                  <el-option
                    v-for="(item, idx) in (type === 'create' ? paymentTypes : originPaymentTypes)"
                    :key="idx"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$locale('global.status')">{{salesStatus[transCreateForm.status]}}</el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$locale('inventoryLog.changePeople')">{{transCreateForm.userName}}</el-form-item>
            </el-col>
          </el-row>
          <div class="line"></div>
          <el-row>
            <el-col :span="20">
              <el-form-item :label="$locale('inventoryLog.inventoryChangeSupplement')">
                <el-input :placeholder="$locale('trans.report.ticketing.plsSelectComment')" v-model="transCreateForm.comment" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer" v-if="type !== 'info'">
        <el-row type="flex" justify="center">
          <el-col :span="6">
            <el-button @click="closeDialog" class="egl-btn-white">{{
              $locale("global.cancel")
            }}</el-button>
          </el-col>
          <el-col :span="6">
            <el-button
              type="primary"
              class="egl-btn-yellow"
              @click="submitForm_fn"
            >
              {{ $locale("global.update") }}
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>
<style scoped>
.makeInline {
  white-space: nowrap;
}
.makeLeft {
  margin-left: 10px;
}
.searchMaxWidth {
  max-width: 350px;
}
</style>

<script>
import "@/assets/style/transactionHistory.less";
import Table from "@/components/Report/table.vue";
// import Dialog from "@/components/Version/dialog.vue";
// import Card from "@/components/Report/card.vue";
import moment from "moment";
// import elTableExport from "el-table-export";
// import json2csv from "json2csv";
import CommPagination from "@/components/common/CommPagination";
import DatePickerGroup from "@/components/DatePickerGroup";
import {
  getProductSalesReportService, delProductSalesReportService, getGoodsListForTransaction, createGoodsTransactionService,
  updateGoodsTransaction, goodsTransactionDetail
} from "@/helpers/service/api/report";
import { salesStatus, taxRatesMap, weekLocaleArray, getOperatorText } from "@/utils/common.js";
import { getPaymentTypeList } from "@/helpers/service/api/device";
import { generateTimeStamp, generateTimeString, hourMinuteLimit_fn } from "@/utils/transaction";
import countDownAlert from "@/utils/countDownAlert";
import { getCouponTypeList } from "@/helpers/service/api/coupon";
import CommDatePicker from "@/components/common/CommDatePicker";
import { exportCSV_fn } from "@/assets/js/transactionStand_exportCSV";
import RemoteSelect from "@/components/common/RemoteSelect";
export default {
  components: {
    Table,
    // Dialog,
    // Card,
    CommPagination,
    DatePickerGroup,
    CommDatePicker,
    RemoteSelect
  },
  created() {
    this.salesStatus = salesStatus;
    this.taxRatesMap = taxRatesMap;
    this.cinemaId = window.localStorage.getItem("cinemaId");
    getPaymentTypeList({
      forPos: "true",
      page: 0,
      pageSize: 9999,
      cinemaId: this.cinemaId,
    }).then(res => {
      this.originPaymentTypes = res.data.data;
      // let _arr = JSON.parse(JSON.stringify(res.data.data)).filter(item => item.type === "cash" || item.type === "creditCard" || item.type === "gmo");
      this.paymentTypes = res.data.data;
    });
    getGoodsListForTransaction({
      cinemaId: this.cinemaId
    }).then(res => {
      this.goodsList = res.data;
    });
    // getCouponTypeList({
    //   cinemaId: this.cinemaId,
    //   page: 0,
    //   pageSize: 9999
    // }).then(res => {
    //   this.couponTypes = res.data.data;
    // });
  },
  mounted() {
    const today = this.$moment().valueOf();
    this.timeValue1 = today;
    this.timeValue2 = today;

    let cinemaId = window.localStorage.getItem("cinemaId") || "";
    if (cinemaId == "") {
      this.loading = false;
      this.$emit("callCinema", "getHistoryList");
      return;
    }

    this.getHistoryList();
  },
  data() {
    return {
      printObj: {
        popTitle: this.$locale("sideMenu.reports.shopTransaction"),
        id: "print",
      },
      cinemaId: "",
      timeValue1: 0,
      timeValue2: 0,
      table: [
        {
          prop: "searchId",
          label: this.$locale("trans.koisk.transid"),
          width: 220
        },
        {
          prop: "transactionCreateTime",
          label: this.$locale("global.date"),
          width: 234
        },
        {
          prop: "productName",
          label: this.$locale("inventoryLog.name"),
          width: 220
        },
        {
          prop: "group",
          label: this.$locale("global.department"),
          width: 170
        },
        {
          prop: "productType",
          label: this.$locale("trans.koisk.salesgroup"),
          width: 170
        },
        {
          prop: "unitPrice",
          label: this.$locale("global.unitPrice"),
          width: 170
        },
        {
          prop: "qty",
          label: this.$locale("global.quantity"),
          width: 120
        },
        {
          prop: "total",
          label: this.$locale("global.amount"),
          width: 120
        },
        {
          prop: "couponTypeName",
          label: this.$locale("global.coupon"),
          width: 200
        },
        {
          prop: "taxRateText",
          label: this.$locale("global.taxRate"),
          width: 100
        },
        {
          prop: "paymentName",
          label: this.$locale("trans.koisk.paymentName"),
          width: 170
        },
        {
          prop: "operator",
          label: this.$locale("inventoryLog.changePeople"),
          width: 170
        },
        {
          prop: "statusText",
          label: this.$locale("global.status"),
          width: 170
        }
      ],
      tableData: [],
      isOpen: false,
      type: "",
      transIndex: 0,
      searchInput: "",
      size: 10,
      currentPage: 0,
      detailData: {},
      count: 0,
      isCreateOpen: false,
      transCreateForm: this.initCreateForm(),
      salesStatus: {},
      taxRatesMap: {},
      originPaymentTypes: [],
      paymentTypes: [],
      goodsList: [],
      couponTypes: [],
      zhFirstName: "",
      zhLastName: "",
      jpFirstName: "",
      jpLastName: "",
      hourMinuteLimit_fn,
      formRules: {
        goodsId: [
          {
            required: true,
            message: this.$locale("trans.report.stand.plsSelectProduct"),
            trigger: "blur",
          },
        ],
        qty: [
          {
            required: true,
            message: this.$locale("form.plsEnterQuantity"),
            trigger: "blur",
          },
        ],
      },
      titleMapping: {
        "create": this.$locale("trans.stand.create"),
        "info": this.$locale("trans.stand.detail"),
        "edit": this.$locale("trans.stand.edit"),
      },
      datePickerOptions: {
        disabledDate: this.dateDisableDate,
      },
      sort: "",
      status_filters: [],
      payment_filters: [],
    };
  },
  methods: {
    getDate(obj) {
      this.timeValue1 = obj.startDate;
      this.timeValue2 = obj.endDate;
    },
    formatDate(timestamp) {
      return moment(timestamp).format("YYYY-MM-DD");
    },
    getHistoryList(param) {
      const that = this;
      const cinemaId = window.localStorage.getItem("cinemaId") || "";
      const requestParma = {
        startDate: that.formatDate(that.timeValue1),
        endDate: that.formatDate(that.timeValue2),
        cinemaId,
        page: 0,
        pageSize: that.size,
        // chineseName: that.zhFirstName || null,
        // chineseLastName: that.zhLastName || null,
        // email: that.email || null,
        // japaneseName: that.jpFirstName || null,
        // japaneseLastName: that.jpLastName || null,
        // phoneNumber: that.phone || null,
        searchId: that.searchInput.replace(' ', '') || null,
        ...param,
        ...this.sort ? { sort: this.sort } : {},
        ...this.status_filters ? { status: this.status_filters } : {},
        ...this.payment_filters ? { paymentTypeId: this.payment_filters } : {},
      };

      getProductSalesReportService(requestParma).then(res => {
        if (res.success) {
          that.count = res.data.count;
          // that.tableData = that.timeFormat(res.data);
          that.tableData = res.data.records;
          that.tableData.map(item => {
            item.operator = getOperatorText(item);
          })
        }
      });
    },
    search() {
      /// has not implement search functions correctly
      this.tableData = [];
      this.getHistoryList();
    },
    toggle(type) {
      this.isCreateOpen = !this.isCreateOpen;
      if (type) {
        this.type = type;
      }
      // index && (this.transIndex = index - 1)
    },
    setDetailData(data) {
      goodsTransactionDetail({
        transactionId: data.transactionId,
        transactionItemId: data.transactionItemId
      }).then(res => {
        const {
          searchId, transactionCreateTime, qty, commercialTypeId, concessionTypeId, goodsPackageId,
          group, unitPrice, total, taxRate, paymentName, itemStatus, transactionId, transactionItemId,
          couponTypeName, description, platform, operator
        } = res.data;
        this.transCreateForm = {
          searchId,
          date: transactionCreateTime,
          hour: this.$moment(transactionCreateTime).format("HH"),
          minute: this.$moment(transactionCreateTime).format("mm"),
          goodsId: commercialTypeId || concessionTypeId || goodsPackageId,
          qty,
          groupId: group,
          unitPrice: unitPrice,
          totalAmount: total,
          taxRate: taxRate,
          paymentTypeId: paymentName,
          status: itemStatus,
          userName: platform + "/" + operator,
          userId: window.localStorage.getItem("accountId"),
          transactionId: transactionId,
          transactionItemId: transactionItemId,
          comment: description,
          couponTypeId: couponTypeName,

        };
      });
    },
    delete(data) {
      const {
        chineseName, chineseLastName, comment, couponTypeId, email, goodsId, japaneseName, japaneseLastName,qty,
        membershipNumber, mobile, paymentTypeId, groupId, searchId, tradeGroupId, unitPrice, taxRate, status,
        transactionId, transactionItemId, userId, userName
      } = this.transCreateForm;
      const curGoodItem = this.goodsList.find(item => item.goodsId === this.transCreateForm.goodsId);
      let confirmHtml = this.type ? "<i class=\"egl-confirm-question\">?</i><span class=\"result-text\">" +
        this.$locale("trans.update.tips") +
        "</span>" :
        "<i class=\"egl-confirm-question\">?</i><span class=\"result-text\">" +
        this.$locale(data.searchId) + this.$locale("version.screen.action.del") +
        "</span>";
      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.confirm"),
        customClass: "egl-confirm",
        closeOnClickModal: false
      }).then(() => {
        if (!this.type) {
          delProductSalesReportService({
            itemId: data.transactionItemId,
            transactionId: data.transactionId,
            userId: window.localStorage.getItem("accountId")
          }).then(() => {
            // for (let i = 0; i < this.tableData.length; i++) {
            //   if (
            //     this.tableData[i].transactionItemId === data.transactionItemId
            //   ) {
            //     this.tableData.splice(i, 1);
            //     return;
            //   }
            // }
            this.search();
          });
        } else {
          updateGoodsTransaction({
            chineseName,
            chineseLastName,
            cinemaId: this.cinemaId,
            comment,
            couponTypeId,
            email,
            groupId,
            goodsId,
            japaneseName,
            japaneseLastName,
            membershipNumber,
            mobile,
            paymentTypeId,
            qty,
            searchId,
            status,
            taxRate,
            timeString: this.timeString,
            totalAmount: this.totalPrice,
            tradeGroupId,
            transactionFinishTime: this.transactionFinishTime,
            transactionId,
            transactionItemId,
            type: curGoodItem ? curGoodItem.type : "",
            unitPrice,
            userId,
            userName
          }).then(res => {
            this.closeDialog();
            if (res.data) {
              countDownAlert({
                content: this.$locale("global.updateSuccessfully"),
                callback: () => {
                  this.getHistoryList();
                }
              });
            }
          });
        }
      });
    },
    setStartTime(value) {
      this.timeValue1 = moment(value).format("YYYY-MM-DD");
    },
    setEndTime(value) {
      this.timeValue2 = moment(value).format("YYYY-MM-DD");
    },
    exportCsv() {
      // const that = this;
      // if (that.tableData.length > 0) {
      //   that.size = 0;
      //   that.$nextTick(function() {
      //     elTableExport(that.$refs.father.$refs.elTable, {
      //       fileName: "export-trans",
      //       type: "csv",
      //       withBOM: false
      //     })
      //       .then(() => {
      //         that.size = 10;
      //       })
      //       .catch(() => {
      //         that.size = 10;
      //       });
      //   });
      // }
      const that = this;
      const cinemaId = window.localStorage.getItem("cinemaId") || "";
      const requestParma = {
        startDate: that.formatDate(that.timeValue1),
        endDate: that.formatDate(that.timeValue2),
        cinemaId,
        page: 0,
        pageSize: 9999,
        chineseName: that.zhFirstName || null,
        chineseLastName: that.zhLastName || null,
        email: that.email || null,
        japaneseName: that.jpFirstName || null,
        japaneseLastName: that.jpLastName || null,
        phoneNumber: that.phone || null,
        searchId: that.id || null,
        ...this.sort ? { sort: this.sort } : {},
        ...this.filters ? { status: this.filters } : {},
      };
      exportCSV_fn(requestParma, this.goodsList, this.timeValue1, this.timeValue2, weekLocaleArray);
    },
    pageChange(value) {
      this.getHistoryList({ page: value - 1 });
    },
    // timeFormat(res) {
    //   let regex = /\B(?=(\d{3})+(?!\d))/g
    //   let arr = res.records || [];
    //   for (let i = 0; i < arr.length; i++) {
    //     arr[i].scheduleStartTime = moment(arr[i].scheduleStartTime).format("YYYY-MM-DD HH:mm");
    //     arr[i].transactionCreateTime = moment(arr[i].transactionCreateTime).format("YYYY-MM-DD HH:mm");
    //     // arr[i].ticketTypePrice =
    //     //   arr[i].ticketTypePrice + arr[i].premiumPrice + arr[i].vipSeatPrice;
    //     arr[i].unitPrice = arr[i].unitPrice.toString().replace(regex,',')
    //     arr[i].total = arr[i].total.toString().replace(regex,',')
    //     arr[i] = {
    //       ...arr[i],
    //       statusText: salesStatus[arr[i].itemStatus],
    //       taxRateText: taxRatesMap[arr[i].taxRate],
    //     }
    //   }
    //   return arr;
    // },
    openCreateDialog() {
      this.isCreateOpen = true;
      this.type = "create";
    },
    closeDialog() {
      this.$refs["createForm"].resetFields();
      this.transCreateForm = this.initCreateForm();
      this.isCreateOpen = false;
      this.type = "";
    },
    initCreateForm() {
      return {
        searchId: "",
        date: this.$moment().startOf("day").valueOf(),
        hour: "",
        minute: "",
        goodsId: "",
        qty: "",
        groupId: "",
        tradeGroupId: "",
        unitPrice: 0,
        taxRate: 0,
        couponTypeId: "",
        paymentTypeId: "",
        userName: window.localStorage.getItem("userName"),
        userId: window.localStorage.getItem("accountId"),
        comment: "",
        chineseName: "",
        chineseLastName: "",
        japaneseName: "",
        japaneseLastName: "",
        phone: "",
        email: "",
        membershipNumber: "",
        status: "success",
      };
    },
    setFinishTime(num) {
      this.transCreateForm.date = num;
    },
    setPrice() {
      const curProductItem = this.goodsList.find(item => item.goodsId === this.transCreateForm.goodsId);
      this.transCreateForm.unitPrice = curProductItem ? curProductItem.price : 0;
      this.transCreateForm.taxRate = curProductItem ? curProductItem.taxRate : 0;
    },
    submitForm_fn() {
      const {
        chineseName, chineseLastName, comment, couponTypeId, email, goodsId, japaneseName, japaneseLastName,qty,
        membershipNumber, mobile, paymentTypeId, groupId, searchId, tradeGroupId, unitPrice, taxRate, status,
        transactionId, transactionItemId, userId, userName
      } = this.transCreateForm;
      const curGoodItem = this.goodsList.find(item => item.goodsId === this.transCreateForm.goodsId);
      this.$refs["createForm"].validate(valid => {
        if (valid) {
          if (this.transCreateForm.hour === "" || this.transCreateForm.minute === "") {
            this.$alert(this.$locale("trans.plsInput.time"));
          }
          else if (this.type === "create") {
            createGoodsTransactionService({
              // accountId: window.localStorage.getItem("accountId"),
              cinemaId: this.cinemaId,
              comment,
              couponTypeId,
              goodsId,
              groupId,
              paymentTypeId,
              qty,
              timeString: this.timeString,
              totalAmount: this.totalPrice,
              tradeGroupId,
              transactionFinishTime: this.transactionFinishTime,
              type: curGoodItem ? curGoodItem.type : "",
              userId,
            }).then(res => {
              if (res.data) {
                this.$alert(this.$locale("global.createSuccessfully"));
                this.getHistoryList();
              }
              // this.closeDialog();
              // countDownAlert({
              //   content: this.$locale("global.createSuccessfully"),
              //   callback: () => {
              //     this.getHistoryList();
              //   }
              // });
            });
          } else {
            this.delete();
          }
        } else {
          setTimeout(() => {
            const isError = document.getElementsByClassName("is-error");
            isError[0].querySelector("input").focus();
          }, 100);
          return false;
        }
      });
    },
    selectCoupon_fn() {
      this.transCreateForm.qty = 1;
    },
    qtyLimit_fn(val) {
      if (val > 1) {
        this.transCreateForm.qty = 1;
      }
    },
    dateDisableDate(time) {
      const _today = this.$moment().startOf("day").valueOf();
      const _curTime = this.$moment(time.getTime()).startOf("day").valueOf();
      return _curTime > _today;
    },
  },
  computed: {
    transactionFinishTime() {
      return generateTimeStamp(this.transCreateForm);
    },
    timeString() {
      return generateTimeString(this.transCreateForm);
    },
    totalPrice() {
      if (!isNaN(this.transCreateForm.qty)) {
        return this.transCreateForm.unitPrice * this.transCreateForm.qty;
      }
      return 0;
    }
  }
};
</script>
